import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfSentimentReportApplicationService } from '../../../core/application/services/sentiment/get-self-sentiment-report.application-service';
import { SelfSentimentReportEntity } from '../../../core/domain/entities/sentiment/self-sentiment-report.entity';
import { GetSelfSentimentReportRequestDto } from '../../dtos/sentiment/get-self-sentiment-report.request.dto';

export class GetSelfSentimentReportQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfSentimentReportApplicationService
  ) {}
  async execute(
    props: GetSelfSentimentReportRequestDto
  ): Promise<SelfSentimentReportEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
